<template>
    <div class="category">
      <!-- <SearchView /> -->
      <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row text-white" style="padding: 15px 110px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Akun
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Akun" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
      <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 600;">
          Akun
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Akun" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
      <div style="margin: 50px 100px 100px;">
      <div class="row">
        <div class="col-12 col-md-2" style="padding-top: 16px;">
          <q-tabs
            v-model="tabs"
            vertical
            inline-label
            dense
            active-color="purple-12"
            class="text-dark-10"
            > 
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Profil Saya" name="profil" />
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Pesanan" name="pesanan" />
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Alamat" name="alamat" />
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Ubah Password" name="password" />
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Pengaturan Akun" name="pengaturan" />
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Keluar" name="keluar" @click="logout()" />
          </q-tabs>
        </div>
        <div class="col-12 col-md-10">
          <q-tab-panels
            v-model="tabs"
            animated
            transition-prev="jump-up"
            transition-next="jump-up"
          >
            <q-tab-panel name="profil">
              <div class="col" style="margin-bottom: 15px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
              <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
                Profil Saya
              </div>
              <!-- <div class="col" style="padding: 15px;"> -->
                <div class="row" style="padding: 0 15px; margin-bottom: 15px;">
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                      Username
                    </div>
                      <q-input class="input-font" v-model="profil.username" outlined placeholder="Username" color="purple-12" dense />
                  </div>
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                      Nama Lengkap
                    </div>
                      <q-input class="input-font" v-model="profil.nama" outlined placeholder="Nama Lengkap" color="purple-12" dense />
                  </div>
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                        Email
                      </div>
                      <q-input class="input-font" v-model="profil.email" outlined placeholder="Email" color="purple-12" dense />
                  </div>
                  <div class="col-6 q-pa-sm">
                      <div class="row input-label">
                        Nomor HP
                      </div>
                      <q-input class="input-font" v-model="profil.hp" outlined placeholder="Nomor HP" color="purple-12" dense />
                  </div>
                <!-- </div> -->
              </div>
              </div>
              <div class="col text-left" style="margin: 15px 0; margin-left: 25px;">
                  <q-btn no-caps color="purple-12" label="Simpan" @click="editProfil()" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
              </div>
            </q-tab-panel>

            <q-tab-panel name="alamat">
              <div class="col" style="margin-bottom: 15px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
              <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
                Alamat
              </div>
              <!-- <div class="col" style="padding: 15px;"> -->
                <div class="row" style="padding: 0 15px; margin-bottom: 15px;">
                  <div class="col-12 q-pa-sm">
                      <div class="row input-label">
                        Alamat Pengiriman
                      </div>
                      <q-input class="input-font" v-model="alamat" outlined placeholder="Alamat Pengiriman" color="purple-12" dense />
                  </div>
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                        Desa / Kelurahan
                      </div>
                    <q-select class="input-font" outlined v-model="des" :options="desa" color="purple-12" placeholder="Desa / Kelurahan" dense transition-show="scale" transition-hide="scale" />
                  </div>
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                        Kode Pos
                      </div>
                      <q-input class="input-font" v-model="pos" outlined placeholder="Kode Pos" color="purple-12" dense />
                  </div>
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                        Kecamatan
                      </div>
                      <q-select class="input-font" outlined v-model="kec" style="color: #C039FF;" :options="kecamatan" color="purple-12" placeholder="Kecamatan" dense transition-show="scale" transition-hide="scale" />
                  </div>
                  <div class="col-6 q-pa-sm">
                    <div class="row input-label">
                        Kabupaten
                      </div>
                      <q-select class="input-font" outlined v-model="kab" :options="kabupaten" color="purple-12" placeholder="Kabupaten" dense transition-show="scale" transition-hide="scale" />
                  </div>
                <!-- </div> -->
              </div>
              </div>
              <div class="col text-left" style="margin: 15px 0; margin-left: 25px;">
                  <q-btn no-caps color="purple-12" label="Simpan" @click="editAlamat()" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
              </div>
            </q-tab-panel>

            <q-tab-panel name="password">
              <div class="col" style="margin-bottom: 15px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
              <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
                Ubah Password
              </div>
              <!-- <div class="col" style="padding: 15px;"> -->
                <div class="row" style="padding: 0 15px; margin-bottom: 15px;">
                  <div class="col-12 q-pa-sm">
                      <div class="row input-label">
                        Password Baru
                      </div>
                      <q-input class="input-font" type="password" v-model="passBaru" outlined placeholder="Password Baru" color="purple-12" dense />
                  </div>
                  <div class="col-12 q-pa-sm">
                      <div class="row input-label">
                        Konfirmasi Password Baru
                      </div>
                      <q-input class="input-font" type="password" v-model="passKonfirm" outlined placeholder="Konfirmasi Password Baru" color="purple-12" dense />
                  </div>
                <!-- </div> -->
              </div>
              </div>
              <div class="col text-left" style="margin: 15px 0; margin-left: 25px;">
                  <q-btn no-caps color="purple-12" label="Ubah Password" @click="editPassword()" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
              </div>
            </q-tab-panel>

            <q-tab-panel name="pengaturan">
              <div class="col" style="margin-bottom: 15px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
              <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
                Pengaturan Akun
              </div>
                <div class="row" style="padding: 0 15px;">
                  <div class="col-12 col-md-6 q-pa-sm">
                      <div class="row" style="padding: 20px 0; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600;">
                        Penghapusan Akun
                      </div>
                  </div>
                  <div class="col-12 col-md-6 q-pa-sm">
                    <div class="col text-right" style="margin: 15px 0;">
                      <q-btn no-caps color="purple-12" label="Hapus Akun" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
                    </div>
                  </div>
              </div>
              </div>
            </q-tab-panel>

            <q-tab-panel name="pesanan">
              <div v-if="lihat_pesanan == false" class="col" style="margin-bottom: 15px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
              <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 2px; border-color: #C039FF; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
                Pesanan Saya
              </div>
                  <div class="col" style="margin: 10px 0;">
                    <!-- <q-infinite-scroll @load="onLoad" :offset="100"> -->
                    <div class="row" v-for="(data, index) in list_pesanan" :key="index" style="padding: 15px;">
                      <div class="col" style="border: solid 1px #E9E9E9; border-radius: 5px;">
                        <div class="row" style="padding: 15px;">
                          <div class="col-12 col-md-8">
                        <div class="row">
                          <div class="col-4 col-md-4" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                              Nomor Pesanan
                          </div>
                          <div class="col-8 col-md-8" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                              <span style="padding-right: 15px;">:</span> {{data.id}}
                          </div>
                          <div class="col-4 col-md-4" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                              Catatan
                          </div>
                          <div class="col-8 col-md-8" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                              <span style="padding-right: 15px;">:</span> {{ data.catatan }}
                          </div>
                          <div class="col-4 col-md-4" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                              Metode Pembayaran
                          </div>
                          <div class="col-8 col-md-8" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                              <span style="padding-right: 15px;">:</span> {{data.metode}}
                          </div>
                        </div>

                      </div>
                      <div class="col-12 col-md-4 text-right">
                            <div class="col-12 col-md-12 text-right produk-price1" style="padding-bottom: 7.5px;">
                              {{data.status}}
                            </div>
                      </div>
                        </div>
                        <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none; font-family: 'Manrope'; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                          <div class="col-6 col-md-3">
                            Total Pesanan
                          </div>
                          <div class="col-6 col-md-3 text-left text-purple-12 text-weight-bolder">
                            Rp. {{ data.total_pesanan }}
                          </div>
                          <div class="col-12 col-md-6 text-right produk-price1">
                              <q-btn no-caps color="purple-12" @click="push_pesanan(data.id), getTotal(data.id)" label="Lihat Pesanan" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
                            </div>
                        </div>
                        </div>
                    </div>
                    <!-- <template v-slot:loading>
                      <div class="row justify-center q-my-md">
                        <q-spinner-dots color="purple-12" size="40px" />
                      </div>
                    </template> -->
                  <!-- </q-infinite-scroll> -->
                    </div>
                    <div class="q-pa-lg flex flex-center">
                      <q-btn @click="btn_prev" round outline size="sm" color="purple-12" icon="chevron_left" />
                      <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
                      <q-btn @click="btn_next" round outline size="sm" color="purple-12" icon="chevron_right" />
                    </div>
              </div>
              <div v-else class="col" style="margin-bottom: 15px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
              <div class="row" style="padding: 10px 0; border-width: 2px; border-color: #C039FF; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                <div class="col-12 col-md-6" style="padding-left: 5px;">
                  <q-btn @click="back_pesanan()" class="btn--no-hover" flat no-caps>
                    <div class="search-btn">
                      <span class="material-symbols-outlined" style="font-size: 18px; padding-bottom: 2px; font-weight: 500;">
                        arrow_back
                      </span>
                    </div>
                    <div style="font-size: 18px; font-weight: 500;">Kembali</div>
                  </q-btn>
                </div>
                <div class="col-12 col-md-6 text-right" style="padding-right: 20px; padding-top: 5px; font-size: 18px; font-weight: 500;">
                  No. Pesanan. {{ no_pesanan }} | <span class="produk-price1">PESANAN {{ status_pesanan }}</span>
                </div>
              </div>
              <div class="row" style="margin: 50px 75px; display: grid; grid-template-columns: repeat(7, 1fr);">
                <div v-if="objek_pesanan == NULL">
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        receipt
                      </span>
                </q-btn>
                  </div>
                <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Dibuat
                </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        receipt
                      </span>
                </q-btn>
                  </div>
                <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Dibuat
                </div>
                </div>
                <div style="padding: 30px 0;">
                  <hr style="width: 179px;" size="7.5" color="#C039FF" noshade />
                </div>
                <div v-if="objek_pesanan == 1">
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        payments
                      </span>
                </q-btn>
                  </div>
                  <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Dibayar
                </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        payments
                      </span>
                </q-btn>
                  </div>
                  <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Dibayar
                </div>
                </div>
                <div style="padding: 30px 0;">
                  <hr style="width: 179px;" size="7.5" color="#C039FF" noshade />
                </div>
                <div v-if="objek_pesanan == 2">
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        local_shipping
                      </span>
                </q-btn>
                  </div>
                  <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Dikirim
                </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        local_shipping
                      </span>
                </q-btn>
                  </div>
                  <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Dikirim
                </div>
                </div>
                <div style="padding: 30px 0;">
                  <hr style="width: 179px;" size="7.5" color="#C039FF" noshade />
                </div>
                <div v-if="objek_pesanan == 3">
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        order_approve
                      </span>
                </q-btn>
                  </div>
                  <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Selesai
                </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        order_approve
                      </span>
                </q-btn>
                  </div>
                  <div class="text-center" style="font-size: 15px; margin: 5px -25px 0">
                  Pesanan Selesai
                </div>
                </div>
                <!-- <div >
                  <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        payments
                      </span>
                </q-btn>
                </div>
                <div style="padding: 30px 0;">
                  <hr style="width: 175px;" size="7.5" color="#C039FF" noshade />
                </div>
                <div>
                  <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        local_shipping
                      </span>
                </q-btn>
                </div>
                <div style="padding: 30px 0;">
                  <hr style="width: 175px;" size="7.5" color="#C039FF" noshade />
                </div>
                <div>
                  <q-btn size="25px" color="purple-12" outline round class="btn--no-hover" no-caps>
                      <span class="material-symbols-outlined" style="font-size: 35px;">
                        order_approve
                      </span>
                </q-btn>
                </div> -->
              </div>
                  <div class="col" style="margin: 10px 0;">
                      <div class="row justify-between" v-for="data in list_produk" style="margin: 20px; padding-top: 20px; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none;">
                          <div class="row">
                            <q-img :src="file_path+data.file" style="width: 100px; height: 75px; border-radius: 2.5px; margin-right: 20px; border: solid #E9E9E9 0.5px"/>
                            <div class="col text-left">
                              <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px;">
                                {{data.brand}}
                              </div>
                              <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px;">
                                {{ data.kategori_uraian }}
                              </div>
                              <div class="row produk-price1">Rp. {{data.harga}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                              <div class="row text-center">
                              X{{ data.keranjang_kuantitas }}
                            </div>
                            </div>
                          </div>
                        <div class="row produk-price1">
                          <div class="col">
                          <div class="row">
                            &nbsp;
                          </div>
                          <div class="row">
                            Rp. {{data.keranjang_total}}
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-between" style="padding: 20px; background-color: antiquewhite; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                      <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px;">
                          Total Pesanan
                        </div>
                        <div class="row produk-price1">Rp. {{total_pesanan}}</div>
                    </div>
              </div>
            </q-tab-panel>

            
          </q-tab-panels>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script>

  import { ref } from 'vue'
  // import SearchView from '@/views/SearchView.vue'
  
  export default {
    name: 'HomeView',
    // components: {
    //   SearchView
    // },
    data () {
      return {
        tabs: ref('profil'),
        list_pesanan : [],
        list_produk : [],
        file_path: this.$store.state.url.URL_APP + "uploads/",
        page_first: 1,
        page_last: 0,
        lihat_pesanan : false,
        no_pesanan : '',
        status_pesanan : '',
        total_pesanan : '',
        objek_pesanan : '',
        step : 2,
        profil : {
          username  : '',
          nama      : '',
          email     : '',
          hp        : '',
        },
        passBaru : '',
        passKonfirm : '',
      }
    },
    methods: {
      getPesanan : function(){
        this.$store.commit('showLoading');
        fetch(this.$store.state.url.URL_AKUN  + "pesanan", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_pesanan = res_data.data;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
                console.log(res_data);
                 
        });
      },

      getProfil : function(){
        this.$store.commit('showLoading');
        fetch(this.$store.state.url.URL_AKUN  + "profil", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
              console.log(res_data);
              this.profil.username = res_data.data[0].username;
              this.profil.nama = res_data.data[0].nama;
              this.profil.email = res_data.data[0].email;
              this.profil.hp = res_data.data[0].hp;
              this.$store.commit("hideLoading");
                 
        });
      },

      editProfil : function(){
        this.$store.commit('showLoading');
        fetch(this.$store.state.url.URL_AKUN  + "editProfil", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.profil)
        })
        .then(res_data => {
          this.Notify('Data Telah Disimpan', 'purple-12', 'check_circle_outline');
          console.log(res_data);
          this.getProfil();
        });
      },

      editPassword : function(){
        if (this.passBaru !== this.passKonfirm) {
          this.Notify('Password & Konfirmasi Password Harus Sama', 'red-12', 'check_circle_outline');
        }
        else {
          
          // this.$store.commit('showLoading');
          fetch(this.$store.state.url.URL_AKUN  + "editKunci", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                password : this.passBaru,
            })
          })
          .then(res_data => {
            this.Notify('Password Telah Diubah', 'purple-12', 'check_circle_outline');
            console.log(res_data);
            this.getProfil();
          });
        }
      },

      Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

      push_pesanan : function(id){
        console.log(id+"dsdfdsfs");
        this.lihat_pesanan = true
        this.$store.commit('showLoading');
        fetch(this.$store.state.url.URL_AKUN  + "produk", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id_pesanan : id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_produk = res_data.data;
                this.no_pesanan = res_data.data[0].pesanan_id;
                this.status_pesanan = res_data.data[0].pesanan_status;
                this.objek_pesanan = res_data.data[0].objek_pesanan;
                console.log("fsdvhfgds");
                
                console.log(this.objek_pesanan+"dsfs");
                this.$store.commit("hideLoading");
                console.log(res_data);
                console.log(this.list_produk);
                
                console.log("fsdvhfgds");
        });
      },

      getTotal : function(id){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_AKUN  + "total", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                id_pesanan : id
            })
      })
          .then(res => res.json())
          .then(res_data => {
            // console.log(res_data);
              this.total_pesanan = res_data.data[0].total_pesanan;
              this.$store.commit("hideLoading");
      });
    },

      back_pesanan : function(){
        this.lihat_pesanan = false;
        this.getPesanan();
      },

      btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getPesanan();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getPesanan();
        },

      async logout() {
        let promise = new Promise((resolve) => {
          resolve(
            this.btn_logout()
          )
        });
        
        await promise; // tunggu sampai promise selesai (*)

        setTimeout(() => {
          this.$store.commit("hideLoading")
          this.$router.go('/');
        }, 750);
      },

        btn_logout() {
          this.$store.commit("showLoading");
          localStorage.removeItem('token');
          localStorage.removeItem('profile'); 
          setTimeout(() => {
            location.reload();
          }, 750);
        },

    //     logout : function(){
    //     this.$store.commit("showLoading");
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('profile'); 
    //     setTimeout(() => {
    //       location.reload();
    //     }, 250);
    //     setTimeout(() => {
    //     this.$store.commit("hideLoading")
    //     this.$router.push('/');
    //     }, 750);
    // },

      onLoad (index, isDone) {
        // console.log(index);
        // this.getPesanan()
        // setTimeout(() => {
          // if(this.page_first >= this.page_last){
          //       this.daftar_pesanan.push(...this.daftar_pesanan, ...this.list_pesanan)
          //       this.page_first == this.page_last
          //       this.getPesanan()
          //   }else{
          //       this.daftar_pesanan.push(...this.daftar_pesanan, ...this.list_pesanan)
          //       this.hal_first++;
          //       this.getPesanan()
          //   }
            // this.daftar_pesanan = [...this.daftar_pesanan, ...this.list_pesanan];
            // isDone(true)   
          // }, 750)
          setTimeout (() => {
            if (this.list_pesanan) {
              fetch(this.$store.state.url.URL_AKUN  + "pesanAkun", {
                    method: "POST",
                    headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    }
                })
                    .then(res => res.json())
                    .then(res_data => {
                      console.log(res_data.result);
                      // this.daftar_pesanan = res_data.result;
                      // console.log(this.daftar_pesanan);
                if (res_data.result.length < 1) {
                  this.noData = true
                } else {
                  // this.daftar_pesanan = JSON.parse(this.daftar_pesanan)
                  res_data.result.forEach((dok) => {
                    this.list_pesanan.push(dok)
                  })
                }
              })
              isDone(true)
            }
          }, 750)
      },
    },
    mounted() {
      this.getPesanan();
      this.getProfil();
    }
  }
  </script>